import PropTypes from 'prop-types';

const CustomerType = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  long_name: PropTypes.string,
  modules: PropTypes.arrayOf(PropTypes.string),
  subdomain: PropTypes.string,
  ach_payment_gateway: PropTypes.string,
  ach_payment_info: PropTypes.object,
  cc_payment_gateway: PropTypes.string,
  cc_payment_info: PropTypes.object,
  stripe_api_key: PropTypes.string,
  stripe_api_version: PropTypes.string,
  stripe_beta_enabled: PropTypes.bool
});

export default CustomerType;
